import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
let notificationId = 1;
export function makeNotification(type, queueName, params) {
    if (params && params.hasOwnProperty('id')) {
        const { id } = params, rest = _object_without_properties(params, [
            "id"
        ]);
        return {
            id,
            queueName,
            type,
            created: Date.now(),
            params: rest
        };
    }
    return {
        id: notificationId++,
        queueName,
        type,
        created: Date.now(),
        params
    };
}
